export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/ob-step-1.png?9b8ba7c08a2ea4a3dc77049a637c6d4a";